import Vue from 'vue'
import router from '@/router'
import store from '@/store'

import { ACCESS_TOKEN, USER_AUTH } from '@/store/variables'
// import { generateIndexRouter } from '@/utils/util'

const whiteList = ['/user/login']

router.beforeEach((to, from, next) => {
  if (Vue.ls.get(ACCESS_TOKEN)) {
    if (to.path === '/user/login') {
      next({ path: '/' })
    } else {
      const authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || '[]')
      if (authList.length === 0) {
        store.dispatch('GetPermissions').then(res => {
          const redirect = decodeURIComponent(from.query.redirect || to.path)
          if (to.path === redirect) {
            next({ ...to, replace: true })
          } else {
            next({ path: redirect })
          }
        }).catch(() => {
          store.dispatch('Logout').then(() => {
            next({ path: 'user/login', query: { redirect: to.fullPath } })
          })
        })
      } else {
        next()
      }
      // if (store.getters.resources.length === 0) {
      //   store.dispatch('GetPermissions').then(res => {
      //     const menuData = res.data.menu
      //     if (menuData === null || menuData === '' || menuData === undefined) {
      //       return
      //     }
      //     let constRoutes = []
      //     constRoutes = generateIndexRouter(menuData)
      //     store.dispatch('UpdateAppRouter', { constRoutes }).then(() => {
      //       router.addRoutes(store.getters.addRouters)
      //       const redirect = decodeURIComponent(from.query.redirect || to.path)
      //       if (to.path === redirect) {
      //         next({ ...to, replace: true })
      //       } else {
      //         next({ path: redirect })
      //       }
      //     })
      //   }).catch(() => {
      //     store.dispatch('Logout').then(() => {
      //       next({ path: 'user/login', query: { redirect: to.fullPath } })
      //     })
      //   })
      // } else {
      //   next()
      // }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1 || to.meta.login === false) {
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
    }
  }
})

router.afterEach(() => {
})
